import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { UiService } from '../models/ui-service';
import { StoreService } from './store.service';

@Injectable({
  providedIn: 'root'
})
export class Ui {
  // 1	Manage users	Gérer les utilisateur	MANAGE_USERS
  // 2	Manage users	Voir les utilisateur	VIEW_USERS
  // 3	Manage users	Gérer les publicités	MANAGE_ADS
  // 4	Manage users	Voir les publicités	VIEW_ADS
  // 5	Manage users	Gérer les services	MANAGE_SERVICES
  // 6	Manage users	Voir les services	VIEW_SERVICES
  // 7	Manage push notifications	Gérer les push notifications	MANAGE_PUSH_NOTIFICATIONS
  // 8	View push notifications	Voir les push notifications	VIEW_PUSH_NOTIFICATIONS
  // 9	Manage push SETTINGS	Gérer les paramètres	MANAGE_SETTINGS
  // 10	View push notifications	Voir les paramètres	VIEW_SETTINGS
  // 11	Manage Offers	Gérer les offres	MANAGE_OFFERS
  // 12	View Offers	Voir les offres	VIEW_OFFERS
  // 13	Manage Agencies	Gérer les agences	MANAGE_AGENCIES
  // 14	View agencies	Voir les agences	VIEW_AGENCIES
  services: UiService[];
  activatedServices: UiService[] = [];

  avalaiblesServices: UiService[] = [
    new UiService({
      id: 'HOME',
      label: 'DASHBOARD',
      icon: 'home',
      url: '/dash',
      root: true
    }),
    new UiService({
      id: 'TELCO.OFFER.PROMO_AND_OFFERS',
      label: 'Offre et Promo',
      icon: 'gift',
      // url: '/offers-promo/offers',
      authorizations: ['MANAGE_OFFERS', 'VIEW_OFFERS', 'MANAGE_SERVICES', 'VIEW_SERVICES'],
      root: true,
      expanded: true,
      childreen: [
        new UiService({
          id: 'TELCO.OFFER.PROMO.OFFERS',
          label: 'Offre et Promo',
          icon: 'gift',
          url: '/offers-promo/offers',
          authorizations: ['MANAGE_OFFERS', 'VIEW_OFFERS'],
          root: true
        }),
        new UiService({
          id: 'TELCO.OFFER.PROMO.SERVICES',
          label: 'Services Telco',
          icon: 'construct',
          url: '/offers-promo/services',
          authorizations: ['MANAGE_SERVICES', 'VIEW_SERVICES'],
          root: true
        }),
        
      ]
    }),
    new UiService({
      id: 'CONFIGS',
      label: 'Configurations',
      icon: 'settings',
      expanded: true,
      // url: '/settings',
      authorizations: [
        'MANAGE_COUNTERS',
        'VIEW_COUNTERS',
        'MANAGE_SETTINGS',
        'VIEW_SETTINGS',
        'MANAGE_FORTUNE_WELL',
        'MANAGE_APP_SERVICES',
        'VIEW_APP_SERVICES',
        'MANAGE_APP_ACCESS',
        'VIEW_APP_ACCESS',
        'MANAGE_FAQ',
        'VIEW_FAQ',
        'MANAGE_AGENCIES',
        'VIEW_AGENCIES',
        'MANAGE_NOTIFICATION_MODELS',
        'VIEW_NOTIFICATION_MODELS',
        'MANAGE_TARRIFS',
        'VIEW_TARRIFS',
        'MANAGE_TONES',
        'VIEW_TONES',
        'MANAGE_LOYALTY',
        'VIEW_LOYALTY',
        'MANAGE_HOME_PROFIT',
        'VIEW_HOME_PROFIT'
      ],
      root: true,
      childreen: [
        new UiService({
          id: 'COUNTERS',
          label: 'Gestion des compteurs',
          icon: 'wallet',
          url: '/counters',
          authorizations: ['MANAGE_COUNTERS', 'VIEW_COUNTERS'],
          root: true
        }),
        new UiService({
          id: 'SETTINGS',
          label: 'Parametrages',
          icon: 'settings',
          url: '/settings',
          authorizations: ['MANAGE_SETTINGS', 'VIEW_SETTINGS'],
          root: true
        }),
        new UiService({
          id: 'NOTIFICATIONS',
          label: 'Notification Messages',
          icon: 'notifications',
          url: '/notifications',
          authorizations: ['MANAGE_NOTIFICATION_MODELS', 'VIEW_NOTIFICATION_MODELS'],
          root: true
        }),
        new UiService({
          id: 'APP_SERVICES_NEWS',
          label: 'App Services',
          icon: 'apps',
          url: '/ui-service',
          authorizations: ['MANAGE_APP_SERVICES', 'VIEW_APP_SERVICES'],
          root: true
        }),
        new UiService({
          id: 'OMS_ACCESS',
          label: 'OMS Access',
          icon: 'lock-closed',
          secondIcon: 'remove-circle',
          url: '/oms-access',
          authorizations: ['MANAGE_APP_ACCESS', 'VIEW_APP_ACCESS'],
          root: true
        }),
        new UiService({
          id: 'TARIF',
          label: 'Tarif',
          icon: 'cash',
          url: '/tarifs',
          authorizations: ['MANAGE_TARRIFS', 'VIEW_TARRIFS'],
          root: true
        }),
        new UiService({
          id: 'DALAL-TONES',
          label: 'Dalal Tones',
          icon: 'musical-notes',
          url: '/dalal-tones',
          authorizations: ['MANAGE_TONES', 'VIEW_TONES'],
          root: true
        }),
        new UiService({
          id: 'FORTUNE_WHELL',
          label: 'Weekend-Gagnant',
          icon: 'football',
          url: '/fortune-whell/configure',
          authorizations: ['MANAGE_FORTUNE_WELL'],
          root: true
        }),
        new UiService({
          id: 'FAQ',
          label: 'FAQ',
          icon: 'help',
          url: '/faq',
          authorizations: ['MANAGE_FAQ', 'VIEW_FAQ'],
          root: true
        }),
        new UiService({
          id: 'AGENCIES',
          label: 'Nos agences',
          icon: 'map',
          url: '/agencies',
          authorizations: ['MANAGE_AGENCIES', 'VIEW_AGENCIES'],
          root: true
        }),
        new UiService({
          id: 'LOYALTY_CARDS',
          label: 'Cartes Sargal',
          icon: 'map',
          url: '/loyalty',
          authorizations: ['MANAGE_LOYALTY', 'VIEW_LOYALTY'],
          root: true
        }),
        new UiService({
          id: 'HOME_PROFIT',
          label: 'J\'en profite',
          icon: 'map',
          url: '/home-profit',
          authorizations: ['MANAGE_HOME_PROFIT', 'VIEW_HOME_PROFIT'],
          root: true
        }),
      ]
    }),

    new UiService({
      id: 'CUSTOMERS',
      label: 'CUSTOMERS',
      icon: 'people',
      url: '/customers',
      authorizations: ['MANAGE_CUSTOMERS'],
      root: true
    }),
    new UiService({
      id: 'ATTACH_CUSTOMERS',
      label: 'ATTACH_CUSTOMERS',
      icon: 'people',
      url: '/rattachement',
      authorizations: ['MANAGE_CUSTOMERS'],
      root: true
    }),

    new UiService({
      id: 'USERS',
      label: 'Profil et Utilisateurs',
      icon: 'people',
      url: '/users',
      authorizations: ['MANAGE_USERS', 'VIEW_USERS'],
      root: true
    }),

    new UiService({
      id: 'COMPLAINS',
      label: 'Reclamations',
      icon: 'help-buoy',
      expanded: true,
      // url: '/sponsorship',
      authorizations: ['MANAGE_USER_COMPLAINS'],
      root: true,
      childreen: [
        new UiService({
          id: 'COMPLAINS.COMPLAIN',
          label: 'Utilisateurs',
          icon: 'people',
          url: '/complains',
          authorizations: ['MANAGE_USER_COMPLAINS'],
        }),
        new UiService({
          id: 'COMPLAINS.FORTUNE_WHELL',
          label: 'Weekend-Gagnant',
          icon: 'people',
          expanded: true,
          authorizations: ['MANAGE_USER_COMPLAINS'],
          childreen: [
            new UiService({
              id: 'COMPLAINS.FORTUNE_WHELL.CODES',
              label: 'Codes d\'accès',
              icon: 'key',
              url: '/fortune-whell/access-codes',
              authorizations: ['MANAGE_USER_COMPLAINS'],
            }),
            new UiService({
              id: 'COMPLAINS.FORTUNE_WHELL.GIFTS',
              label: 'Cadeaux',
              icon: 'gift',
              url: '/fortune-whell/gifts',
              authorizations: ['MANAGE_USER_COMPLAINS'],
            }),
          ]
        }),
      ],
    }),

    new UiService({
      id: 'SPONSORSHIP',
      label: 'Parainage',
      icon: 'people',
      authorizations: [
        'VIEW_SPONSORSHIP',
        'HISTORIQUE_SPONSORING',
        'CONFIGURE_SPONSORING',
        'MANAGE_SPONSORING'
      ],
      childreen: [
        new UiService({
          id: 'SPONSORSHIP.HISTORIQUE',
          label: 'Historique',
          icon: 'pie-chart',
          url: '/sponsorship/historic',
          authorizations: [
            'VIEW_SPONSORSHIP',
            'HISTORIQUE_SPONSORING',
            'CONFIGURE_SPONSORING',
            'MANAGE_SPONSORING'
          ],
        }),
      ]
    }),
    new UiService({
      id: 'ADVERTISINGS',
      label: 'Campagnes',
      icon: 'send',
      expanded: true,
      // url: '/push-notifications',
      authorizations: ['MANAGE_ADS', 'VIEW_ADS', 'MANAGE_STORIES', 'VIEW_STORIES'],
      root: true,
      childreen: [

        new UiService({
          id: 'ADS',
          label: 'Publicités',
          icon: 'paper-plane',
          url: '/ads',
          authorizations: ['MANAGE_ADS', 'VIEW_ADS'],
          root: true
        }),
        new UiService({
          id: 'STORIES',
          label: 'Stories',
          icon: 'paper-plane',
          url: '/stories',
          authorizations: ['MANAGE_STORIES', 'VIEW_STORIES'],
          root: true
        }),
        new UiService({
          id: 'STORIES-LITE',
          label: 'Stories Lite',
          icon: 'paper-plane',
          url: '/stories-lite',
          authorizations: ['MANAGE_STORIES', 'VIEW_STORIES'],
          root: true
        }),
        new UiService({
          id: 'STORIES-WIDO',
          label: 'Stories Wido',
          icon: 'paper-plane',
          url: '/stories-wido',
          authorizations: ['MANAGE_STORIES', 'VIEW_STORIES'],
          root: true
        }),
        new UiService({
          id: 'STORIES-CONNERS-OFFERS',
          label: 'Corner Offres',
          icon: 'gift',
          url: '/corner-offers',
          authorizations: ['MANAGE_STORIES', 'VIEW_STORIES'],
          root: true
        }),
        new UiService({
          id: 'STORIES-CONNERS-SECTION',
          label: 'Corner Section',
          icon: 'gift',
          url: '/corner-section',
          authorizations: ['MANAGE_STORIES', 'VIEW_STORIES'],
          root: true
        }),
        new UiService({
          id: 'STORIES-CONNERS-MEDIA',
          label: 'Corner Media',
          icon: 'gift',
          url: '/corner-media',
          authorizations: ['MANAGE_STORIES', 'VIEW_STORIES'],
          root: true
        }),
        new UiService({
          id: 'KDO-ANIMATION-MEDIA',
          label: 'Animation',
          icon: 'gift',
          url: '/animation',
          authorizations: ['MANAGE_STORIES', 'VIEW_STORIES'],
          root: true
        }),
        new UiService({
          id: 'KDO-GAIN-MEDIA',
          label: 'Gain',
          icon: 'gift',
          url: '/gain',
          authorizations: ['MANAGE_STORIES', 'VIEW_STORIES'],
          root: true
        }),
        // new UiService({
        //   id: 'STORIES-CONNERS-CUSTOMER',
        //   label: 'Clients Cible',
        //   icon: 'gift',
        //   url: '/target-customer',
        //   authorizations: ['MANAGE_STORIES', 'VIEW_STORIES'],
        //   root: true
        // }),
        new UiService({
          id: 'STORIES-CONNERS-MANAGE',
          label: 'Config Formule & Clients',
          icon: 'gift',
          url: '/target-config',
          authorizations: ['MANAGE_STORIES', 'VIEW_STORIES'],
          root: true
        }),
        new UiService({
          id: 'STORIES-CONNERS-MANAGE',
          label: 'Corners TV',
          icon: 'gift',
          url: '/corner-tv',
          authorizations: ['MANAGE_STORIES', 'VIEW_STORIES'],
          root: true
        }),
        
      ]
    })
  ];
  omyServices = [
    new UiService({
      id: 'OMY.TRANSFERT',
      translationKey: 'TRANSFERT_MONEY',
      label: ' Transferer de l\'argent',
      icon: 'orange-transfert',
      // avatar: '/assets/v1/s-transfert-icon.svg',
      url: '/omy/transfert/from-wallet',
      root: true
    }),

    new UiService({
      id: 'OMY.ORANGE_PRODUCT',
      label: 'Produit Orange',
      translationKey: 'ORANGE_PRODUCT',
      // icon: 'orange-tarif', produits-orange
      icon: 'produits-orange',
      // avatar: 'assets/v1/ic_produits_orange.png',
      tags: 'OMY.ORANGE_PRODUCTS',
      url: '/omy/payments/orange-products/root',
    }),
    new UiService({
      id: 'OMY.ORANGE_LOISIR',
      label: 'Orange Loisir',
      translationKey: 'ORANGE_LOISIR',
      icon: 'orange-loisir',
      tags: 'OMY.ORANGE_LOISIR',
      url: '/omy/orange-loisir',
      cssClass: 'loisir',
    }),
    new UiService({
      id: 'OMY.TOPUP',
      translationKey: 'TELCO_WITH_OMY',
      label: 'Recharge pour moi ou pour un proche',
      // avatar: '/assets/v1/s-topup-icon.svg',
      icon: 'orange-topup',
      url: '/omy/telco',
      root: true
    }),
    new UiService({
      id: 'OMY.PAY.WITH.QRCODE',
      translationKey: 'PAY_WITH_QRCODE',
      label: ' Sarali/Qrcode',
      cssClass: 'sarali',
      icon: 'orange-qrcode',
      // avatar : '/assets/v1/qrcode_test.png',
      url: '/omy/qrcode-payment',
      root: true
    }),

    new UiService({
      id: 'OMY.ORANGEPRODUCT.POSTPAID',
      label: 'Facture Pospaid',
      translationKey: 'FACTURE_POSTPAID',
      avatar: 'assets/v1/orange-mini.png',  // orange-mini
      tags: 'OMY.ORANGEPRODUCT',
    }),

    new UiService({
      id: 'OMY.ORANGEPRODUCT.FLYBOX',
      label: 'Flybox',
      translationKey: 'FLYBOX',
      avatar: 'assets/v1/ic_sobox_logo.png',
      // avatar: 'assets/v1/ic_flybox_logo.png',
      tags: 'OMY.ORANGEPRODUCT',
    }),

    new UiService({
      id: 'MARKET.ESHOP',
      translationKey: 'MARKET',
      label: 'Orange Shop',
      icon: 'apps',
      url: '/market',
    }),
  ];
  constructor(private router: NavController, private settings: StoreService) {
    this.services = <any>this.avalaiblesServices.map(e => {
      this.uiItemClick(e);
      return e;
    });
  }

  private uiItemClick(e: UiService) {
    if (e.childreen && e.childreen.length > 0) {
      for (const c of e.childreen) {
        this.uiItemClick(c);
      }
      e.onClick = e.onClick || (() => {
        e.expanded = !e.expanded;
      });
      return e;
    }
    e.onClick = e.onClick || (() => {
      if (!e.url) {
        return;
      }
      if (!this.hasPermission(e)) {
        return;
      }
      return !e.root ? this.router.navigateForward(e.url, {
        animated: true,
      }) : this.router.navigateRoot(e.url, {
        animated: true,
      });
    });
    e.expanded = false;
    return e;
  }

  ensurePermission(perm) {
    return this.settings.tmp.actions.includes(perm);
  }
  hasPermission(service: UiService) {
    let r = false;
    if (!service || !service.authorizations || service.authorizations.length === 0) {
      return true;
    }
    let droit = service.authorizations;
    if (!Array.isArray(droit)) {
      droit = [droit];
    }
    droit.forEach(d => r = r || this.settings.tmp.actions.includes(d));
    return r;
  }
}
